export function createEmptyBudgetRow() {
  return {
    id: crypto.randomUUID(),
    category: "",
    ongoingBudget: 0,
    ongoingSpent: 0,
    impliedOngoing: 0,
    ongoingDelta: 0,
    irregularBudget: 0,
    irregularSpent: 0,
    irregularDelta: 0
  };
}

export function isEmptyBudgetRow(row) {
  return !String(row.category ?? "").trim()
    && Number(row.ongoingBudget ?? 0) === 0
    && Number(row.irregularBudget ?? 0) === 0;
}

export function isCompleteBudgetRow(row) {
  return Boolean(String(row.category ?? "").trim())
    && Number.isFinite(Number(row.ongoingBudget))
    && Number.isFinite(Number(row.irregularBudget));
}
